/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { StyleSheet } from 'react-native-unistyles';

const styles = StyleSheet.create((pd) => ({
  row: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: pd.ref.space.spacing60.px,
  },
  item: {
    alignItems: 'center',
  },
  gap: {
    height: pd.ref.space.spacing20.px,
  },
}));

export default styles;
